import {
  CONSIGNMENT_REQUEST_SET,
  CONSIGNMENT_REQUEST_RESET,
} from "../actionNames";

const initialState = {
  data: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CONSIGNMENT_REQUEST_SET:
      return {
        ...state,
        data: action.consignment,
      };

    case CONSIGNMENT_REQUEST_RESET:
      return {
        ...state,
        data: undefined,
      };

    default:
      return state;
  }
};
